const IAB_PATTERNS = [
  { pattern: /FBAN|FBAV|FBIOS|FB_IAB/i, name: 'Facebook' },
  { pattern: /Instagram/i, name: 'Instagram' },
  { pattern: /musical_ly|TikTok/i, name: 'TikTok' },
  { pattern: /LinkedInApp/i, name: 'LinkedIn' },
  { pattern: /TwitterAndroid|Twitter for iPhone/i, name: 'X (Twitter)' },
  { pattern: /Snapchat/i, name: 'Snapchat' },
  { pattern: /\bLine\//i, name: 'Line' },
  { pattern: /MicroMessenger/i, name: 'WeChat' },
  { pattern: /Pinterest/i, name: 'Pinterest' },
];

// Returns { detected: boolean, name: string|null } — name is the app name if identifiable.
export function detectInAppBrowser() {
  const ua = navigator.userAgent || '';
  for (const { pattern, name } of IAB_PATTERNS) {
    if (pattern.test(ua)) return { detected: true, name };
  }
  return { detected: false, name: null };
}

export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Attempts to open the current URL in the Android default browser via an intent URI.
// The OS intercepts the intent and routes it to whichever browser the user has set as default.
// Returns true if the attempt was made (Android only — iOS has no equivalent API).
export function tryOpenExternalBrowser() {
  if (!isAndroid()) return false;
  const url = window.location.href;
  window.location.href = 'intent://' + url.replace(/^https?:\/\//, '') + '#Intent;scheme=https;action=android.intent.action.VIEW;end';
  return true;
}
